import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="risikolebensversicherung"
export default class extends Controller {
	static targets = ["linear", "annuitaetisch"]
	connect() {}

	updateModus({ currentTarget }) {
		this.linearTarget.classList.add("hidden")
		this.annuitaetischTarget.classList.add("hidden")

		switch (currentTarget.value) {
			case "1":
				break
			case "2":
				this.linearTarget.classList.remove("hidden")
				break
			case "3":
				this.annuitaetischTarget.classList.remove("hidden")
				break
		}
	}
}
